const login = () => import("@/views/login/login.vue");
const phoneLogin = () => import("@/views/login/phoneLogin.vue");

export default [
	{
		path: '/login', // 注册
		name: 'login',
		component: login,
		meta: {
			title: '注册',
			keepAlive: false
		}
	},
	{
		path: '/phoneLogin', // 手机号注册
		name: 'phoneLogin',
		component: phoneLogin,
		meta: {
			title: '手机号注册',
			keepAlive: false
		}
	},
]